export const initialState = {
  content: {},
};
